import React from 'react';
import { normalizeReportData } from '../engine/normalizeReportData';
import { KPI_REGISTRY } from '../registry/kpis';
import { formatMetric } from '../engine/formatMetric';

export default function ReportTemplateV2(props) {
  const data = normalizeReportData(props);

  const totals = Object.values(data.raw.campaignInsights).reduce((acc, v) => {
    acc.spend       += v.spend       || 0;
    acc.impressions += v.impressions || 0;
    acc.clicks      += v.clicks      || 0;
    acc.reach       += v.reach       || 0;
    return acc;
  }, { spend: 0, impressions: 0, clicks: 0, reach: 0 });

  return (
    <div style={{ padding: 40, fontFamily: 'system-ui' }}>
      <h1>{data.context.client}</h1>
      <p>{data.context.dateFrom} → {data.context.dateTo}</p>
      <h2>Overview</h2>
      {['spend', 'impressions', 'reach', 'clicks', 'ctr', 'cpm'].map(key => {
        const kpi = KPI_REGISTRY[key];
        const raw = kpi.resolve({ totals });
        const value = formatMetric(raw, kpi.format);
        return (
          <div key={key} style={{ marginBottom: 8 }}>
            <strong>{kpi.label}:</strong> {value}
          </div>
        );
      })}
    </div>
  );
}
